export function useTimeUtils() {
  function secondsToHigherUnit(duration) {
    let result = "NaN Error";
    if (!isNaN(duration)) {
      const minutes = Math.floor(duration / 60);
      if (minutes >= 60) {
        const hours = Math.floor(minutes / 60);
        if (hours >= 24) {
          const days = Math.ceil(hours / 24);
          if (days >= 7 && days < 31) {
            const weeks = Math.floor(days / 7);
            result = `${weeks} sem.`;
          } else if (days >= 31) {
            const months = Math.floor(days / 31);
            if (months >= 12) {
              const years = Math.floor(months / 12);
              result = `${years} an${years > 1 ? "s" : ""}`;
            } else {
              result = `${months} mois`;
            }
          } else {
            result = `${days} jour${days > 1 ? "s" : ""}`;
          }
        } else {
          result = `${hours} h`;
        }
      } else {
        result = `${minutes} min${minutes > 1 ? "s" : ""}`;
      }
    }

    return result;
  }

  return {
    secondsToHigherUnit,
  };
}
